






















































































































































































import { defineComponent, onMounted } from "@vue/composition-api";
import SvgGeometry from "../SvgGeometry.vue";
import BuildingsCharacteristics from "./BuildingsCharacteristics.vue";
import Block from "../Block.vue";
import Icon from "../Icon.vue";
import { useUtils, useCheckout, useGlobal } from "@front/store";
import { useUser } from "@front/store/user";
import { updateRouteLocation } from "@front/router";

export default defineComponent({
  components: {
    Block,
    Icon,
    SvgGeometry,
    BuildingsCharacteristics,
  },

  setup() {
    onMounted(() => {
      // if (getRouteStep.value === ScrollIds.POTENTIAL) {
      // scrollToElement(`#${ScrollIds.POTENTIAL}`, {
      //   block: "start",
      // });
      // }
    });

    return {
      ...useUser(),
      ...useUtils(),
      ...useCheckout(),
      ...useGlobal(),
      updateRouteLocation,
    };
  },
});
